export enum Environments {
	DEV = 'dev',
	CI = 'ci',
	QA = 'qa',
	AT = 'at',
	TR = 'tr',
	COLD = 'cd',
	PROD = 'pd'
}

export enum EnvironmentNames {
	DEV = 'Development',
	CI = 'CI',
	QA = 'QA',
	AT = 'Pilot',
	TR = 'Training',
	COLD = 'Cold',
	PROD = 'Production'
}
